module.exports = __webpack_public_path__ + "static/img/17d759f.ef4daa0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/17d759f.png
// module id = cSpA
// module chunks = 1